import React, { useEffect } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'

export default function Success() {
  const { oid } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const resultPrompt = location.state?.resultPrompt || "提交成功"

  useEffect(() => {
    document.title = '提交成功'
  }, [])

  const handleReturn = () => {
    navigate('/' + oid)
  }

  return (
    <div className='success-page'>
      <div className='success-main'>
        <div className='success-icon'>
          <img src="/chenggong.png" alt="" />
        </div>
        <div className='success-title'>{resultPrompt}</div>
        <div className='success-button' onClick={handleReturn}>返回</div>
      </div>
    </div>
  )
}
